import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-266369c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-end" }
const _hoisted_2 = { class: "middle-container mb-16" }
const _hoisted_3 = { class: "middle-content mb-16" }
const _hoisted_4 = { class: "row row-cols-2 mb-16" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row mb-16" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row row-cols-3" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-xxl-4 mb-16 mb-xxl-24"
}
const _hoisted_11 = { class: "col-12 col-xxl-4 mb-16 mb-xxl-24" }
const _hoisted_12 = { class: "col-12 col-xxl-4 mb-16 mb-xxl-24" }
const _hoisted_13 = { class: "section-title fw-bold mb-8" }
const _hoisted_14 = {
  key: 0,
  class: "comments-container"
}
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = {
  key: 0,
  class: "text-disabled fw-normal text-xs me-4"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 1,
  class: "text-disabled fw-normal text-xs ms-4"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "bottom-section d-flex align-items-center justify-content-end" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-save me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_form_group_read_only_text = _resolveComponent("v-form-group-read-only-text")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_form_group_textarea = _resolveComponent("v-form-group-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.interConsultation.status !== 'closed')
        ? (_openBlock(), _createBlock(_component_v_button, {
            key: 0,
            variant: "secondary",
            "aria-label": _ctx.$t('Finalizar interconsulta'),
            onClick: _ctx.finalizeInterConsultation
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Finalizar interconsulta')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_form_group_read_only_text, {
              label: _ctx.$t('Fecha'),
              text: _ctx.$str.formatDateTime(_ctx.interConsultation.createdAt)
            }, null, 8, ["label", "text"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_form_group_input_text, {
              value: _ctx.title,
              label: _ctx.$t('Título'),
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.title = $event)),
              autocomplete: "off"
            }, null, 8, ["value", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_form_group_textarea, {
              label: _ctx.$t('Descripción'),
              idKey: "description",
              value: _ctx.description,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.description = $event))
            }, null, 8, ["label", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.interConsultation.expedient)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_v_form_group_read_only_text, {
                  label: _ctx.$t('Paciente'),
                  text: `${_ctx.interConsultation.expedient.patient.user.name}
            ${_ctx.interConsultation.expedient.patient.user.surname}`
                }, null, 8, ["label", "text"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_form_group_read_only_text, {
              label: _ctx.$t('Con'),
              text: `${_ctx.interConsultation.targetProfessional.name} ${_ctx.interConsultation.targetProfessional.surname}`
            }, null, 8, ["label", "text"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_v_form_group_read_only_text, {
              label: _ctx.$t('De'),
              text: `${_ctx.interConsultation.creatorProfessional.name} ${_ctx.interConsultation.creatorProfessional.surname}`
            }, null, 8, ["label", "text"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('Comentarios')), 1),
      (_ctx.interConsultation.comments && _ctx.interConsultation.comments.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interConsultation.comments, (comment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: comment.id,
                class: _normalizeClass(["d-flex", {'justify-content-end text-end': comment.isOwner === 1}])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (comment.isOwner === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$str.formatDateTime(comment.createdAt)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      innerHTML: _ctx.displayProfessionalUsername(comment)
                    }, null, 8, _hoisted_18),
                    (comment.isOwner !== 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$str.formatDateTime(comment.createdAt)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(comment.content), 1)
                ])
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('No hay comentarios')), 1))
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_v_button, {
        variant: "link-secondary",
        class: "me-24",
        "aria-label": _ctx.$t('Cancelar'),
        onClick: _ctx.emitShowInterConsultationEvent
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('Cancelar')), 1)
        ]),
        _: 1
      }, 8, ["aria-label", "onClick"]),
      (_ctx.can('professional.inter-consultation.update'))
        ? (_openBlock(), _createBlock(_component_v_button, {
            key: 0,
            variant: "secondary",
            class: "btn-icon",
            "aria-label": _ctx.$t('Guardar'),
            onClick: _ctx.updateInterConsultation
          }, {
            default: _withCtx(() => [
              _hoisted_22,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Guardar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}